import { render } from "./Snippet.vue?vue&type=template&id=206b0cfc&scoped=true"
import script from "./Snippet.vue?vue&type=script&lang=js"
export * from "./Snippet.vue?vue&type=script&lang=js"

import "./Snippet.vue?vue&type=style&index=0&id=206b0cfc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206b0cfc"]])

export default __exports__